import {
    getClientOdooLoading,
    getClientOdooReject,
    getClientOdooRequest,
    getClientOdooSuccess
} from "../../actions/client/getAllOdoo";

export const getClientOdoo = (formData) => async (dispatch, getState) => {
    dispatch(getClientOdooLoading());
    try {
        const { data } = await getClientOdooRequest(formData, getState);
        dispatch(getClientOdooSuccess(data))
    } catch (error) {
        dispatch(getClientOdooReject(error))
    }
    return Promise.resolve();
};
